import { Elements } from '@mul-pay/mptoken-react-js';
import { TokenResponse } from '@mul-pay/mptoken-js';
import { MulpayElementForm } from '../MulpayElementForm';

import { useMulpay } from 'src/components/gmo-pg/MulpayProvider';

export const MulpayFormWrapper = ({
  onChange,
}: {
  onChange: (tokenResponse?: TokenResponse) => void;
}) => {
  const multiPayment = useMulpay();

  return (
    <Elements multiPayment={multiPayment}>
      <MulpayElementForm onChange={onChange} />
    </Elements>
  );
};
